"use client";

import { useLanguage } from "@/contexts/LanguageContext";
import nanailsLogo from "@/assets/logos/nanails.svg";
import citymouvLogo from "@/assets/logos/citymouv.svg";
import feextiLogo from "@/assets/logos/feexti.svg";
import komyuLogo from "@/assets/logos/komyu.svg";
import teemupLogo from "@/assets/logos/teemup.svg";
import mightyfaceLogo from "@/assets/logos/mightyface.svg";

const translations = {
  en: { trustedBy: "They trusted us" },
  fr: { trustedBy: "Ils nous ont fait confiance" },
};

const logos = [
  { name: "Nanails", src: nanailsLogo },
  { name: "Citymouv", src: citymouvLogo },
  { name: "Feexti", src: feextiLogo },
  { name: "Komyu", src: komyuLogo },
  { name: "Teemup", src: teemupLogo },
  { name: "Mighty Face", src: mightyfaceLogo },
];

export function LogoMarquee() {
  const { lang } = useLanguage();
  const t = translations[lang];

  // Triple logos for seamless infinite scroll
  const duplicatedLogos = [...logos, ...logos, ...logos];

  return (
    <div className="relative py-12 overflow-hidden border-y border-white/[0.05] bg-card/20 backdrop-blur-sm">
      {/* Title */}
      <p className="text-center text-muted-foreground text-sm md:text-base mb-10 tracking-wide">
        {t.trustedBy}
      </p>
      {/* Gradient overlays for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-24 sm:w-36 md:w-48 lg:w-72 bg-gradient-to-r from-background via-background/95 to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-24 sm:w-36 md:w-48 lg:w-72 bg-gradient-to-l from-background via-background/95 to-transparent z-10" />

      {/* CSS-only marquee animation - static Tailwind class */}
      <div className="flex overflow-hidden">
        <div className="flex gap-20 md:gap-32 items-center animate-marquee-scroll">
          {duplicatedLogos.map((logo, index) => (
            <div key={index} className="flex items-center flex-shrink-0">
              <img 
                src={logo.src} 
                alt={`Logo de ${logo.name}, client d'Azurys`} 
                loading="lazy"
                decoding="async"
                width={120}
                height={48}
                className="h-14 sm:h-14 md:h-16 w-auto opacity-70 hover:opacity-100 transition-opacity"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
